import React from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import SignIn from "../pagesadmin/SignIn";
import LoadingOverlayWrapper from "react-loading-overlay-ts";
import { useSelector } from "react-redux";

const TheLoginLayout = () => {
  const statusLoading = useSelector((state) => state.globalLoading.status);
  return (
    <LoadingOverlayWrapper active={statusLoading} spinner>
      <div>
        <SignIn />
      </div>
      <ToastContainer />
    </LoadingOverlayWrapper>
  );
};

export default TheLoginLayout;
